import { createApp } from 'vue'
import Mortgage from './Mortgage.vue'
import './assets/global.css'

createApp(Mortgage).mount('#mortgage')
